import { GetThirdPartSceneList,IsExistGSDevice } from '@/axios/IDevice.js'
import { FindScene } from '@/axios/IScene.js'
import { alertsuccess, warning } from '@/assets/js/common.js'
import { postWebIOSocket } from '@assets/socket';
import { getImageSceneWindowRoute, isTransportImageScene } from '@/utils/imageSceneRoute'

const freeMixins = {
  props:{
    isCantEdit: {
      type: Boolean,
      default: false
    },
  },

  data () {
    return {
      thirdPartSceneList: [],
      isExistGSDevice: false, //是否存在保利设备
      dialogSun: false,
            gelansibeiActionList: [
        {
          IsShow: true,
          ischeck: true,
          MsgType: '0x03120000',
          ShowMode: -1,
          Desc: this.$t('sceneCard.workStatus'),
          Values: [
            {
              KeyId: 1,
              ValueType: 'UIControl_Radio_Baoli',
              Name: this.$t('sceneCard.workStatus'),
              DefaultValue: 0,
              Min: 0,
              Max: 3,
              EnumValue: [
                { Name: this.$t('sceneCard.sensor'), Value: 0 },
                { Name: this.$t('sceneCard.alwaysOpen'), Value: 1 },
                { Name: this.$t('sceneCard.alwaysClose'), Value: 2 },
                { Name: this.$t('sceneCard.sleep'), Value: 3 },
              ],
              IsShow: true,
              Type: '0x0207'
            }
          ],
          ControlType: 11
        },
        {
          IsShow: true,
          ischeck: true,
          MsgType: '',
          ShowMode: -1,
          Desc: this.$t('sceneCard.sceneNumber'),
          Values: [
            {
              KeyId: 1,
              ValueType: 'UIControl_Scene_Baoli',
              Name: this.$t('sceneCard.sceneNumber'),
              DefaultValue: '1',
              Min: '1',
              EnumValue: [],
              IsShow: true,
              Type: null
            }
          ],
          ControlType: 10
        }
      ],
    }
  },

  methods: {
    ifttt (index) {
      this.iftttOption[index].is_del = false
    },
    async openSceneDetail(scene) {
      if (!scene || !scene.SceneNo || scene.IsDel) {
        return
      }

      const gpNo = scene.GpNo || this.parameters?.GpNo || this.gpNo
      let sceneItem = scene

      try {
        const res = await FindScene({ sceneNo: scene.SceneNo })
        if (res.StatusCode === this.$store.state.rightStatusCode && res.Result) {
          sceneItem = { ...scene, ...res.Result }
        }
      } catch (error) {
        console.log(error)
      }

      if (sceneItem.AutoTemplateParams?.DataContent?.isCanEdit === false) {
        return
      }

      let controlParams = JSON.parse(getLocalStoragItem('control') || '{}') || {}
      controlParams.SceneNo = sceneItem.SceneNo
      controlParams.GpNo = sceneItem.GpNo || gpNo || controlParams.GpNo
      setLocalStoragItem('control', JSON.stringify(controlParams))

      let routeData = null

      if (isTransportImageScene(sceneItem)) {
        routeData = getImageSceneWindowRoute(sceneItem, controlParams.GpNo, 'edit')
      } else {
        const query = sceneItem.AutoTemplateParams ? {
          TemplateId: sceneItem.AutoTemplateParams.Id,
          Editable: true,
          ServiceType: sceneItem.AutoTemplateParams.ServiceType,
          Gpno: sceneItem.AutoTemplateParams.GpNo,
          isFromTemplate: true
        } : null

        routeData = { name: 'sceneHandle', query }
      }

      const route = this.$router.resolve(routeData)
      window.open(route.href, '_blank')
    },
    handleSunConfirm(data){
      const timeMode = data.TimeMode != null ? data.TimeMode : data.Mode
      const offset = data.Offset || 0
      this.sunOption = {
        TriggerType: 3,
        Mode: timeMode,
        Offset: offset,
        Longitude: data.Longitude,
        Latitude: data.Latitude,
        Label: data.TimeLabel
      }
      this.dialogSun = false
      this.setDisabled('g')
    },
    modifySun() {
      this.dialogSun = true
    },
    /**
     * 获取是否存在格兰斯贝设备
     */
    async getIsExistGSDevice(){
      try {
        const res = await IsExistGSDevice();
        this.isExistGSDevice = res.Result
        if (this.isExistGSDevice) {
          const {Result} = await  GetThirdPartSceneList({BrandId:1024})
          this.thirdPartSceneList = Result
        }
        this.addSceneOnList()

        if (this.parameters.IFT_ID) {
          //编辑自动化   inno旋钮不需要获取详情
          if(!this.isInnoTrigger){
            this.doFind()
          }
        } else {
          //创建自动化 改
          // this.dataOk()
        }
      } catch (error) {
        console.log(error)
      }
    },

    areaselectfinsh () {
      if (this.temparealist.length > 0) {
        this.tempareaactionPannel = true
        this.dialogAreaSelect = false
      } else {
        warning(this, this.$t('iftttset.SelecArea'))
      }
    },

    // 格兰斯贝相关内容
    addSceneOnList(){
      if (!this.isExistGSDevice) return;

      this.gelansibeiActionList = this.gelansibeiActionList.map((item) => {
        if (item.Values[0].ValueType == 'UIControl_Scene_Baoli') {
          return {
            ...item,
            Values: item.Values.map((value, index) => 
              index === 0 ? { ...value, EnumValue: this.thirdPartSceneList } : value
            )
          };
        }
        return item;
      });
    },

    iftttSetParamDefault () {
      return {
        GpNo: null,
        IFtttName: '',
        IsEnable: true,
        IsManual: false,
        TRI_Relation: 0,
        TriggerType: 4,
        TriggerList: [
          {
            AreaName: null,
            DeviceName: '',
            VDeviceId: '',
            TriggerType: 1,
            TriggerList: [
              {
                ExtraKeyId: 2,
                KeyId: 2,
                MsgId: '',
                OperationType: 1,
                Value1: 6
              }
            ]
          }
        ],
        ExecuteTaskList: [
        ],
        TimePeriod: {
          time: '00:00',
          weeks: 'Mon Tues Wed Thur Fri Sat Sun',
          zone: 480
        }
      }
    },

    doUIControlChooseRangeChange () {
      this.fileSizeShow = false
      const _this = this
      setTimeout(function () {
        _this.fileSizeShow = true
      }, 1)
    },

    triggerAndActionWarmTip() {
      const param = this.$t('iftttset.triggerandactiontip')
      const parts = param.split('#')
      return parts.length === 5 
        ? parts[0] + this.$store.state.deployParamter.ifttt.triggershowtotal + parts[2] + this.$store.state.deployParamter.ifttt.actionshowtotal + parts[4] 
        : param
    },

    triggerObjAdddataShowTips() {
      const param = this.$t('iftttset.triggershowtotaltip');
      const parts = param.split('#');

      return parts.length === 3 ? parts[0] + this.$store.state.deployParamter.ifttt.triggershowtotal + parts[2] : param;
    },

    actionObjAdddataShowTips() {
      const param = this.$t('iftttset.actionshowtotaltip');
      const parts = param.split('#');

      return parts.length === 3 ? parts[0] + this.$store.state.deployParamter.ifttt.actionshowtotal + parts[2] : param;
    },

    setOtaWarnFlag(){
      this.otaWarnFlag = false;
    },

    automaticalTurnOnOff(title1,title2) {
      // 获取国际化翻译字符串
      let param = this.$t('iftttset.automaticalTurnOnOff')

      // 检查字符串中是否包含 '#' 字符
      if (param.indexOf('#') >= 0) {
        // 将字符串按 '#' 分割成数组
        param = param.split('#');
        
        // 如果分割后的数组长度为 5
        if (param.length === 5) {
          param = param[0]  + title1 + param[2] + title2 + param[4];
          return param;
        }
      }
      
      // 如果不包含 '#' 或数组长度不为 5，返回原始翻译字符串
      return this.$t('iftttset.triggerandactiontip');
    },

    /**
     * 修改action回调
     * @param {*} info action对象
     * @param {*} model 
     * @param {*} _type 修改后的值
     */
    doCallActionClassSku(actionInfo,info, model, _type,color,value) {
      console.log('.....修改action回调',actionInfo,info,_type,value)
    },

    delsuccess () {
      alertsuccess(this, this.$store.state.rightStatusCode)
    },

    handleClose (done) {
      postWebIOSocket('sync_info_removeall_event')
      done && done()
    },

    cancle (e) {
      if (this.isCustomBack) {
        this.$emit('back');
        return;
      };

      if (this.isJumpBackPage === false && e == null) { return }

      history.back()
    },
  }
};

export default freeMixins;